import script from "./Manage.vue?vue&type=script&setup=true&lang=ts"
export * from "./Manage.vue?vue&type=script&setup=true&lang=ts"

import "./Manage.vue?vue&type=style&index=0&id=56fb05d7&lang=css"

const __exports__ = script;

export default __exports__